import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
export class ConfirmationNotificationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    handelAcceptConfirmation = (okCancel) => {
        this.props.handleModal(okCancel)
    }
    render() {
        const {
            isDecisionModal,
            isSaving
        } = this.props;

        return (
            <>
                <Modal
                    show={this.props.show}
                    onHide={this.props.handleModal}
                    backdrop="static"
                    keyboard={false}
                    className={`custom-column-modal-container confirmation-blur-background ${this.props.customClass}`}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="message-body">
                            {this.props.message}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            disabled={this.props.disabled}
                            onClick={() =>
                                this.handelAcceptConfirmation(
                                    CONFIRMATION_VALUE.Cancel
                                )
                            }
                        >
                            {
                                isDecisionModal
                                    ? "No"
                                    : this.props.discardBtn
                                        ? "Discard"
                                        : "Cancel"
                            }
                        </Button>
                        <Button variant="primary" className={`${isSaving ? 'custom-modal__save' : ''}`} disabled={this.props.disabled} onClick={() => this.handelAcceptConfirmation(CONFIRMATION_VALUE.Ok)}>
                            {isSaving ? <div className="spinner-border saving spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                         : isDecisionModal ? "Yes" : this.props.discardBtn ? "Confirm" : "Yes"}</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
